import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loan-calculator-page',
  templateUrl: './loan-calculator-page.component.html',
  styleUrls: ['./loan-calculator-page.component.scss']
})
export class LoanCalculatorPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
